import React from "react";
import {Box, CircularProgress, Typography} from "@mui/material";

const BlurredComponent = ({ children, isBlurred, message }) => {
    return (
        <Box sx={{ position: "absolute", display: "inline-block" }}>
            {/* Размытие фона и надпись */}
            {isBlurred && (
                <Box
                    sx={{
                        marginTop: '60px',
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backdropFilter: "blur(3px)", // Размытие
                        //backgroundColor: "rgba(255, 255, 255, 0.3)", // Полупрозрачный фон
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 200, // Выше контента
                    }}
                >
                    <CircularProgress

                        sx={{
                            position: 'absolute',
                            marginTop:'-380px' }} />
                    <Typography
                        sx={{
                            marginTop:'-300px'
                        }}
                        variant="h5">
                        {message}
                    </Typography>
                </Box>
            )}

            {/* Основной контент */}
            <Box sx={{ filter: isBlurred ? "blur(3px)" : "none", transition: "0.3s" }}>
                {children}
            </Box>
        </Box>
    );
};

export default BlurredComponent;
